import React from 'react'
import Zoom from 'react-medium-image-zoom'
import styled from 'styled-components'
import EmbeddedYouTubeVideo from '../EmbeddedYouTubeVideo/EmbeddedYouTubeVideo'
import Image from '../../atoms/images/images'
import TypographyAtom from '../../atoms/typography/typography'
import { brandOrange } from '../../../assets/consts/color'

const CopyWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 0 20px 0;
  padding-left: 24px;
  position: relative;

  &:before {
    background-color: ${brandOrange};
    content: '';
    height: 100%;
    left: 0;
    position: absolute;
    width: 4px;
  }

  h4 {
    margin: 0 0 8px 0;
    font-weight: bold;
  }

  @media only screen and (min-width: 48em) {
    margin: 0;
  }
`

function DroneOperationsCard({ title, description, youTubeLink, videoFile, posterImage }) {
  return (
    <div>
      <div className="margin-24">
        {posterImage && (
          <div>
            <Zoom zoomMargin={45} classDialog="custom-zoom">
              <Image
                imgSrc={posterImage?.gatsbyImageData}
                altTag={posterImage?.title}
                hasFrame="Left Clip"
                aspectRatio="16/9"
              />
            </Zoom>
          </div>
        )}
        {youTubeLink && !posterImage && !videoFile && (
          <div className="video-wrapper">
            <EmbeddedYouTubeVideo youTubeLink={youTubeLink} />
          </div>
        )}
        {videoFile && !posterImage && !posterImage && (
          <div className="video-wrapper">
            <video width="100%" height="auto" controls>
              <source src={videoFile} type="video/mp4" />
            </video>
          </div>
        )}
      </div>
      {title && description && (
        <CopyWrapper>
          <h4>{title}</h4>
          <TypographyAtom type="BlockText" copyBlock={description} weight="BlockText" />
        </CopyWrapper>
      )}
    </div>
  )
}

export default DroneOperationsCard
